import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './Safety.css';

const Safety = () => {
    return (
        <section className="about-content-sec">
            <Container>
                <Row>
                    <Col md={12} lg={12} className="text-center safety-Text">
                        <div className="section-title">
                            <h1>Safety First</h1>
                        </div>
                        <p className="w-75 m-auto content-inner">At our center, safety is paramount. We prioritize your well-being from the moment you step through our doors. Our facilities adhere to the highest standards of cleanliness and hygiene. With a dedicated focus on your safety, our experienced team ensures a secure environment for your physiotherapy journey. Trust us to provide not only effective treatments but also a space where your health and safety come first.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Safety;